document.addEventListener('DOMContentLoaded',() => {
    function up() {
        const prevEle = document.querySelector('.shopify-section:last-child').previousElementSibling;
        document.querySelector('.shopify-section:last-child').style.opacity = 0;
        document.body.style.overflow = 'hidden';
        prevEle.classList.remove('is-show');
        if (prevEle.querySelector('.block-inner')) {
            prevEle.querySelector('.block-inner').classList.add('is-show')
            if (prevEle.querySelector('.block-inner video')) {
                prevEle.querySelector('.block-inner video').play()
            }
        }
    }
    if(document.querySelector('.shopify-section:last-child')){
        document.querySelector('.shopify-section:last-child').addEventListener('wheel',(event) => {
            if (event.deltaY < 0 && window.innerWidth >= 768) {
                up()
            }
        })
        let startY = 0;
        let endY = 0;

        document.querySelector('.shopify-section:last-child').addEventListener("touchstart", (e) => {
            startY = e.touches[0].clientY; // vị trí Y ban đầu
        });

        document.querySelector('.shopify-section:last-child').addEventListener("touchend", (e) => {
            endY = e.changedTouches[0].clientY; // vị trí Y khi kết thúc
            let diffY = startY - endY;

            if (diffY < -30) {
                up();
            }
        });
    }
})
class Block1 extends HTMLElement {
    constructor() {
        super();
        this.effect = this.dataset.effect;
    }
    connectedCallback() {
        document.querySelectorAll('.shopify-section:not([class*="block-"])').forEach(section => {
            section.style.opacity = 0
        })
        document.body.style.overflow = 'hidden';
        this.addEventListener(this.effect, (event) => {
            if (event.deltaY > 0 || this.effect == "click") {
                this.down()
            }
        })
        let startY = 0;
        let endY = 0;

        this.addEventListener("touchstart", (e) => {
            startY = e.touches[0].clientY; // vị trí Y ban đầu
        });

        this.addEventListener("touchend", (e) => {
            endY = e.changedTouches[0].clientY; // vị trí Y khi kết thúc
            let diffY = startY - endY;

            if (diffY > 30) {
                this.down()
            } else if (diffY < -30) {
                this.up()
            }
        });
    }
    down() {
        this.classList.remove('is-show');
        this.querySelector('video').pause()
        if (document.querySelector('.block-2-inner')) {
            document.querySelector('.block-2-inner').classList.add('is-show')
            document.querySelector('.block-2-inner video').currentTime = 0;
            document.querySelector('.block-2-inner video').play()
        }
    }
}
customElements.define("block-1", Block1)
class Block2 extends HTMLElement {
    constructor() {
        super();
        this.effect = this.dataset.effect;
        this.backToPrevBlock = this.querySelector('.go-to-prev-block');
    }
    connectedCallback() {
        document.body.style.overflow = 'hidden';
        this.addEventListener("wheel", (event) => {
            if (event.deltaY > 0 ) {
                this.down()
            }
        })
        this.addEventListener("click", (event) => {
            this.down()
        })
        if (this.backToPrevBlock) {
            this.up()
        }
        this.querySelector('video').addEventListener('ended', (event) => {
            this.down()
        });

        let startY = 0;
        let endY = 0;

        this.addEventListener("touchstart", (e) => {
            startY = e.touches[0].clientY; // vị trí Y ban đầu
        });

        this.addEventListener("touchend", (e) => {
            endY = e.changedTouches[0].clientY; // vị trí Y khi kết thúc
            let diffY = startY - endY;

            if (diffY > 30) {
                this.down()
            } else if (diffY < -30) {
                this.up()
            }
        });
    }
    down() {
        this.classList.remove('is-show');
        this.querySelector('video').pause()
        if (document.querySelector('.block-3-inner')) {
            document.querySelector('.block-3-inner').classList.add('is-show')
        }
    }
    up() {
        document.body.style.overflow = 'hidden';
        this.classList.remove('is-show');
        if (this.parentElement.previousElementSibling.querySelector('.block-inner')) {
            this.parentElement.previousElementSibling.querySelector('.block-inner').classList.add('is-show')
            if (this.parentElement.previousElementSibling.querySelector('.block-inner video')) {
                this.parentElement.previousElementSibling.querySelector('.block-inner video').play()
            }
        }
        this.backToPrevBlock.addEventListener('click', () => {
            document.body.style.overflow = 'hidden';
            this.classList.remove('is-show');
            if (document.querySelector('.block-1-inner')) {
                document.querySelector('.block-1-inner').classList.add('is-show')
            }
        })
    }
}
customElements.define("block-2", Block2)
class Block3 extends HTMLElement {
    constructor() {
        super();
        this.index = 1;
        this.backto = this.dataset.backto;
    }
    connectedCallback() {
        document.body.style.overflow = 'hidden';
        this.addEventListener('wheel', (event) => {
            if (event.deltaY > 0 && (this.index == 2 || window.innerWidth >= 768)) {
                this.down()
            } else if (event.deltaY > 0 && this.index == 1 && window.innerWidth < 768) {
                this.nextBlock()
            } else if (event.deltaY < 0 && this.index == 2 && window.innerWidth < 768) {
                this.prevBlock()
            } else if (event.deltaY < 0 && (this.index == 1 || window.innerWidth >= 768)) {
                this.up()
            }
        })
        let startY = 0;
        let endY = 0;

        this.addEventListener("touchstart", (e) => {
            startY = e.touches[0].clientY; // vị trí Y ban đầu
        });

        this.addEventListener("touchend", (e) => {
            endY = e.changedTouches[0].clientY; // vị trí Y khi kết thúc
            let diffY = startY - endY;

            if (diffY > 30) {
                if (this.index == 1 && this.querySelector('.block-image[data-index="2"]')) {
                    this.nextBlock()
                } else {
                    this.down()
                }
            } else if (diffY < -30) {
                if (this.index == 2 && this.querySelector('.block-image[data-index="1"]')) {
                    this.prevBlock()
                } else {
                    this.up();
                }
            }
        });
    }
    down() {
        if (this.parentElement.nextElementSibling?.classList?.contains('block-3')) {
            this.parentElement.nextElementSibling.querySelector('.block-inner').classList.add('is-show')
        } else {
            document.body.removeAttribute('style')
            document.querySelectorAll('.shopify-section:not([class*="block-"])').forEach(section => {
                section.style.opacity = ''
            })
            this.parentElement.nextElementSibling.style.opacity = 1;
        }
        this.classList.remove('is-show');
    }
    up() {
        this.index = 1;
        document.body.style.overflow = 'hidden';
        this.classList.remove('is-show');
        if (this.backto == "previous" && this.parentElement.previousElementSibling.querySelector('.block-inner')) {
            this.parentElement.previousElementSibling.querySelector('.block-inner').classList.add('is-show')
            if (this.parentElement.previousElementSibling.querySelector('.block-inner video')) {
                this.parentElement.previousElementSibling.querySelector('.block-inner video').play()
            }
        } else if (document.querySelector('.block-' + this.backto)) {
            document.querySelector('.block-' + this.backto).querySelector('.block-inner').classList.add('is-show')
            if (document.querySelector('.block-' + this.backto).querySelector('.block-inner video')) {
                document.querySelector('.block-' + this.backto).querySelector('.block-inner video').play()
            }
        }
    }
    nextBlock() {
        if(this.querySelector('.block-image[data-index="1"]')){
            this.querySelector('.block-image[data-index="1"]').classList.remove('active')
        }
        if(this.querySelector('.block-image[data-index="2"]')){
            this.index = 2;
            this.querySelector('.block-image[data-index="2"]').classList.add('active')
        }
    }
    prevBlock() {
        if(this.querySelector('.block-image[data-index="1"]')){
            this.index = 1;
            this.querySelector('.block-image[data-index="1"]').classList.add('active')
        }
        if(this.querySelector('.block-image[data-index="2"]')){
            this.querySelector('.block-image[data-index="2"]').classList.remove('active')
        }
    }
}
customElements.define("block-3", Block3)